import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import InternalShell, { useInternalApi } from '../layouts/InternalShell';
import { CRM_NAV } from './nav';

const Lifecycle: React.FC = () => {
    const { api } = useInternalApi();
    const [cohorts, setCohorts] = useState<any[]>([]);
    const [totals, setTotals] = useState<any>(null);
    const [note, setNote] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => { document.title = 'Patient Lifecycle - Uzima Internal'; }, []);
    useEffect(() => {
        api.get('crm-api/lifecycle/').then(r => {
            if (r.data?.status === 'success') {
                setCohorts(r.data.data.cohorts || []);
                setTotals(r.data.data.totals);
                setNote(r.data.data.note || '');
            }
        }).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <InternalShell activeDashboard="customer_relations" subNav={CRM_NAV}>
            <h2 className="fw-bold mb-1"><FontAwesomeIcon icon={faChartLine} className="me-2 text-primary" />Patient Lifecycle & Retention</h2>
            <p className="text-muted mb-4">Joining cohorts by month, and how many went on to have real clinical activity</p>

            {loading || !totals ? (
                <div className="text-center py-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>
            ) : (
                <>
                    <div className="row mb-4">
                        {[
                            { label: 'Total patients', value: totals.patients, color: '' },
                            { label: 'With clinical activity', value: totals.with_activity, color: 'text-success' },
                            { label: 'Never active', value: totals.never_active, color: 'text-warning' },
                            { label: 'Deactivated', value: totals.deactivated, color: 'text-muted' },
                        ].map(s => (
                            <div className="col-md-3 mb-3" key={s.label}>
                                <div className="card border-0 shadow-sm"><div className="card-body">
                                    <div className="text-muted small mb-1">{s.label}</div>
                                    <h4 className={s.color}>{s.value}</h4>
                                </div></div>
                            </div>
                        ))}
                    </div>

                    <div className="alert alert-secondary small"><FontAwesomeIcon icon={faInfoCircle} className="me-2" />{note}</div>

                    <div className="card border-0 shadow-sm">
                        <div className="card-header bg-white"><strong>Joining cohorts</strong></div>
                        <div className="card-body p-0">
                            {cohorts.length === 0 ? (
                                <div className="text-center py-5 text-muted">No patients joined in the last 12 months.</div>
                            ) : (
                                <table className="table table-hover align-middle mb-0">
                                    <thead className="table-light"><tr><th>Month joined</th><th>Joined</th><th>With activity</th><th>Engagement</th></tr></thead>
                                    <tbody>
                                        {cohorts.map(c => (
                                            <tr key={c.month}>
                                                <td>{c.month}</td>
                                                <td>{c.joined}</td>
                                                <td>{c.with_activity}</td>
                                                <td style={{ minWidth: 160 }}>
                                                    <div className="progress" style={{ height: 6 }}>
                                                        <div className={`progress-bar ${c.engagement_pct >= 50 ? 'bg-success' : 'bg-warning'}`}
                                                            style={{ width: `${c.engagement_pct}%` }} />
                                                    </div>
                                                    <span className="small text-muted">{c.engagement_pct}%</span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </>
            )}
        </InternalShell>
    );
};

export default Lifecycle;
